import { RootState } from '../store'

export const cargosSelector = (state: RootState) => {
  const { cargos } = state

  return cargos
}
